import { useState } from "react";
import { useTranslation } from "react-i18next";

import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
/**
 * @COMPONENT_NAME CommonCodeSlaveCreateButton
 * @DESCRIPTION 공통코드 슬레이브 생성을 위한 버튼으로 mstCodeId 값을 넘겨주기 위해 커스텀 버튼 생성
 *
 * @PROPS
 *   - {string} id - 컴포넌트 ID
 *   - {Object} schema - 테이블 스키마 정보
 *   - {Object} refresh - API refresh 객체
 *   - {Function} onSuccess - 성공 시 콜백
 *   - {Object} selectedmst - 선택된 마스터 데이터
 *   - {...any} others - 기타 props
 *
 * @CALLBACKS
 *   - {Function} onOpen - 버튼 클릭 시 호출되는 콜백
 *   - {Function} onClose - 다이얼로그 닫기 시 호출되는 콜백
 *   - {Function} onCreateSuccess - 생성 성공 시 호출되는 콜백
 *   - {Function} setInitialDataCallback - 초기 데이터 설정 콜백
 *   - {Function} checkFormValidationCallback - 폼 데이터 검증 콜백
 *
 */
function CommonCodeSlaveCreateButton(props) {
	const { t } = useTranslation();

	const {
		id,
		schema,
		refresh,
		onSuccess,
		selectedmst,
		...others
	} = props;

	const [open, setOpen] = useState(false);
	const [initialFormData, setInitialFormData] = useState();

	const onOpen = () => {
		setOpen(true);
		setInitialFormData(undefined);
	};

	const onClose = () => {
		setOpen(false);
	};

	const onCreateSuccess = (msg) => {
		if (onSuccess) {
			onSuccess(msg);
		}

		if (refresh) {
			refresh.refresh();
		}
	};

	const setInitialDataCallback = (formData) => {
		if (initialFormData) {
			for (let key in initialFormData) {
				formData[key] = initialFormData[key];
			}
		}

		if (selectedmst) {
			formData["mstCodeId"] = selectedmst.mstCodeId;
		}
	};

	const modifyFormDataCallback = (formData) => {
		setInitialFormData(formData);
	};

	return (
		<>
			<CreateRecordButtonLayout
				id={id + "create-button"}
				onClick={onOpen}
				{...others}
			/>
			<AutoFormDialog
				id={id + "create-dialog"}
				mode="create"
				formId={id + "create-form"}
				title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
				schema={schema}
				initialData={initialFormData}
				open={open}
				onClose={onClose}
				onSuccess={onCreateSuccess}
				setInitialDataCallback={setInitialDataCallback}
				modifyFormDataCallback={modifyFormDataCallback}
			/>
		</>
	);
}

export default CommonCodeSlaveCreateButton;
